exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4628aa97] .ant-form-item-required-71 .ant-form-item-label > label::before {\n  display: inline-block;\n  margin-right: 4px;\n  color: #f5222d;\n  font-size: 14px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: \"*\";\n}\n", ""]);

// exports
